<div class="border-radius-bottom m-2 main-black p-4 white-box">
	<div class="my-4">
		<sct-custom-table
			[data]="schedFunctions"
			[columnsConfig]="columnConfig"
			[config]="config">
		</sct-custom-table>
	</div>
</div>
